import React, {useEffect, useState} from 'react'
import {
  MapContainer,
  TileLayer,
  GeoJSON as LeafletGeoJSON,
  useMap,
  ZoomControl,
} from 'react-leaflet'
import {Geometry, GeoJsonObject} from 'geojson' // Correct import statement
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import euroGeoJSON from './custom.geo.json'

// Interface for GeoJSON feature properties (adjust based on your GeoJSON structure)
interface FeatureProperties {
  abbrev: string
  color: string
}

interface PolygonGeometry {
  type: 'Polygon'
  coordinates: number[][][] // Adjust the structure based on your GeoJSON data
}

interface Feature<P> {
  type: 'Feature'
  geometry: PolygonGeometry | null // Adjust to match the expected geometry structure
  properties: P
}

interface CustomGeoJSONProps {
  data: GeoJsonObject
  onEachFeature: (feature: Feature<FeatureProperties>, layer: any) => void
}

const CustomGeoJSON: React.FC<CustomGeoJSONProps> = ({data, onEachFeature}) => {
  const [geoJSONLayer, setGeoJSONLayer] = useState<any>(null)

  useEffect(() => {
    if (geoJSONLayer) {
      geoJSONLayer.setStyle({color: 'blue', weight: 1, dashArray: '3'})
    }
  }, [geoJSONLayer])

  const onEachFeatureWrapper = (feature: any, layer: any) => {
    onEachFeature(feature, layer)
    setGeoJSONLayer(layer)
  }

  return (
    <LeafletGeoJSON
      data={data}
      style={{color: 'white', weight: 1}}
      onEachFeature={onEachFeatureWrapper}
    />
  )
}

const EuropeMaps: React.FC = () => {
  const handleFeatureClick = (e: any) => {
    // Handle the click event for features with abbrev === 'Fr.'
    const clickedAbbrev = e.target.feature.properties.abbrev

    // Example using React Router's useNavigate:
    if (clickedAbbrev === 'Fr.') {
      window.location.href = '/fr/respiratory-sydroms-in-social-media'
    }
    if (clickedAbbrev === 'Ger.') {
      window.location.href = '/ge'
    }
  }
 
  const onEachFeature = (feature: Feature<FeatureProperties>, layer: any) => {
    const {color, abbrev} = feature.properties

    if (abbrev === 'Fr.' || abbrev === 'Ger.') {
      layer.setStyle({
        fillColor: 'blue',
        fillOpacity: 0.7,
        color: 'white',
        weight: 1,
      })
      layer.on({
        click: handleFeatureClick,
      })
    } else if (
      abbrev === 'Sp.' ||
      abbrev === 'Rom.' ||
      abbrev === 'Italy' ||
      abbrev === 'Pol.' ||
      abbrev === 'Swe.' ||
      abbrev === 'Fin.' ||
      abbrev === 'Nor.'
    ) {
      layer.setStyle({
        fillColor: '#7C95D2',
        fillOpacity: 0.7,
        color: 'white',
        weight: 1,
      })
    } else {
      layer.setStyle({
        fillColor: 'white',
        fillOpacity: 0.7,
        color: 'white',
        weight: 1,
      })
    }

    layer.on({
      mouseover: (e: any) => {
        const currentLayer = e.target
        const {color, abbrev} = feature.properties

    if (abbrev === 'Fr.' || abbrev === 'Ger.') {
      currentLayer.setStyle({
        fillColor: 'blue',
        fillOpacity: 0.7,
        color: 'white',
        weight: 1,
      })
      currentLayer.on({
        click: handleFeatureClick,
      })
    } else if (
      abbrev === 'Sp.' ||
      abbrev === 'Rom.' ||
      abbrev === 'Italy' ||
      abbrev === 'Pol.' ||
      abbrev === 'Swe.' ||
      abbrev === 'Fin.' ||
      abbrev === 'Nor.'
    ) {
      currentLayer.setStyle({
        fillColor: '#7C95D2',
        fillOpacity: 0.7,
        color: 'white',
        weight: 1,
      })
    } else {
      currentLayer.setStyle({
        fillColor: 'white',
        fillOpacity: 0.7,
        color: '#7C95D2',
        weight: 1,
      })
    }
     
   
      },
      mouseout: (e: any) => {
        const currentLayer = e.target
        const {color, abbrev} = feature.properties

    if (abbrev === 'Fr.' || abbrev === 'Ger.') {
      currentLayer.setStyle({
        fillColor: 'blue',
        fillOpacity: 0.7,
        color: '#7C95D2',
        weight: 1,
      })
      currentLayer.on({
        click: handleFeatureClick,
      })
    } else if (
      abbrev === 'Sp.' ||
      abbrev === 'Rom.' ||
      abbrev === 'Italy' ||
      abbrev === 'Pol.' ||
      abbrev === 'Swe.' ||
      abbrev === 'Fin.' ||
      abbrev === 'Nor.'
    ) {
      currentLayer.setStyle({
        fillColor: '#7C95D2',
        fillOpacity: 0.7,
        color: '#7C95D2',
        weight: 1,
      })
    } else {
      currentLayer.setStyle({
        fillColor: 'white',
        fillOpacity: 0.7,
        color: 'white',
        weight: 1,
      })
    }
      },
    })
  }
  return (
    <>
      <MapContainer
        style={{height: '700px', width: '100%', backgroundColor: 'white'}}
        center={[46.6031, 1.726]}
        zoom={1}
        minZoom={4} // Adjust the minimum and maximum zoom levels as needed
        maxZoom={10}
      >
        <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
        <MapContent />
        <CustomGeoJSON data={euroGeoJSON as GeoJsonObject} onEachFeature={onEachFeature} />
      </MapContainer>
    </>
  )
}

// MapContent component to set dynamic view
const MapContent: React.FC = () => {
  const map = useMap()

  useEffect(() => {
    map.setView([51.1657, 10.4515], 4)
  }, [map])

  return null
}

export default EuropeMaps
